import { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { useWishList } from '@src/quince-site-common/src/hooks/useWishList'
import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import { FC, SyntheticEvent } from 'react'

import { IconButton } from '../../../atoms'
import DeleteIcon from '../icons/delete.inline.svg'
import { useProductCardContext } from '../product-card-context/product-card.context'

import styles from './delete-wishlist.module.scss'

export const ProductCardDeleteFromWishlist: FC<{
  deleteItemClassName?: string
}> = props => {
  const { t } = useTranslation('common')
  const { product, selectedOptions } = useProductCardContext()

  const { removeItemFromWishList } = useWishList()

  const onWishListToggle = (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    removeItemFromWishList(product, selectedOptions).catch((e: unknown) => {
      console.error(e)
    })
  }

  if (product.type === PRODUCT_TYPES.BUNDLE) return null
  return (
    <IconButton
      className={classnames(props.deleteItemClassName, styles.defaultButton)}
      iconClassName={classnames(styles.icon)}
      iconSvg={DeleteIcon}
      onClick={onWishListToggle}
      ariaLabel={t('remove_from_wishlist')}
    />
  )
}
